const Orders = () =>
    import ('../../views/Orders.vue')
const OrderDetails = () =>
    import ('../../views/OrderDetails.vue')
const ReviewCart = () =>
    import ('../../views/ReviewCart.vue')
const Payment = () =>
    import ('../../views/Payment.vue')
const OrderStatus = () =>
    import ('../../views/OrderStatus.vue')
const Rating = () =>
    import ('../../views/Rating.vue')
const TrackOrder = () =>
    import ('../../views/TrackOrder.vue')
const BookingHistory = () =>
    import ('../../views/ReservationHistory.vue')
const LiveTrackOrder = () =>import ('../../views/LiveTrack.vue')
const Invoice = () =>import ('../../views/Invoice.vue')
const ChowmanPayOrderDetails = () =>import ('../../views/ChowmanPayOrderDetails.vue')    
  

const order = [{
        path: 'orders',
        name: 'orders',
        component: Orders
    },
    {
        path: 'order-details/:order_id',
        name: 'order-details',
        component: OrderDetails
    },
    {
        path: 'order-status/:order_id',
        name: 'order-status',
        component: OrderStatus
    },
    {
        path: 'rating/:order_id',
        name: 'rating',
        component: Rating
    },
    {
        path: 'review-cart',
        name: 'review-cart',
        component: ReviewCart
    },
    {
        path: 'payment',
        name: 'payment',
        component: Payment
    },
    {
        path: 'trackorder/:order_id',
        name: 'trackorder',
        component: TrackOrder
    },
    {
        path: 'reservation-list',
        name: 'bookinghistory',
        component: BookingHistory
    },
    {
        path: 'livetrackorder/:order_id',
        name: 'livetrackorder',
        component: LiveTrackOrder
    },
    {
        path: 'chowman-pay-detail/:order_id',
        name: 'ChowmanPayOrderDetails',
        component: ChowmanPayOrderDetails
    },
    // {
    //     path: 'orders-invoice/:order_id',
    //     name: 'orders-invoice',
    //     component: Invoice
    // },
]

export default order;